"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIXELS_PER_ANGLED_LABEL = exports.MINIMUM_LABEL_LENGTH = exports.MAXIMUM_AXIS_HEIGHT_RATIO = exports.LABEL_CHARACTER_WIDTH = exports.DEFAULT_PADDING = exports.ANGLED_TICK_LABEL_ANGLE = exports.ANGLED_LABEL_CHARACTER_HEIGHT = void 0;
/**
 * Constants used by ../helpers/CalculateLayout for calculating the layout of charts
 * that are rendered on an xy grid (cartesian charts).
 */

/** The default padding to use for charts that do not have their labels sized responsively */
var DEFAULT_PADDING = exports.DEFAULT_PADDING = {
  top: 5,
  bottom: 40,
  left: 55,
  right: 15
};
/**
 * The minimum amount of characters that should be kept while shortening "outlier"
 * labels (labels that are more than one standard deviation longer than the average).
 * Useful for when all labels are short and thus none should be shortened. This may
 * not be the final label lengths that are rendered in the chart.
 */
var MINIMUM_LABEL_LENGTH = exports.MINIMUM_LABEL_LENGTH = 10;
/**
 * Approximate pixel width of an axis label character. May need to be tuned in
 * future to accomodate shared styles. Need to use an approximation since there
 * is no way to know apriori what css styles are being applied on the page.
 */
var LABEL_CHARACTER_WIDTH = exports.LABEL_CHARACTER_WIDTH = 11;
/**
 * Approximate pixel height of label character when angled (at 45 degrees). This may
 * need to be adjusted in the future if we change anypoint-styles. Need to use an
 * approximation since there is no way to know apriori what css styles are being applied
 * on the page.
 */
var ANGLED_LABEL_CHARACTER_HEIGHT = exports.ANGLED_LABEL_CHARACTER_HEIGHT = 6;
/** The angle to use when the x axis needs to make room for more labels */
var ANGLED_TICK_LABEL_ANGLE = exports.ANGLED_TICK_LABEL_ANGLE = -45;
/**
 * The maximum percentage of the chart height that we are willing to let the x axis
 * take up vertically.
 */
var MAXIMUM_AXIS_HEIGHT_RATIO = exports.MAXIMUM_AXIS_HEIGHT_RATIO = 0.4;
/**
 * A hand-tuned value for the amount of pixels of width that should be given
 * to an angled label (before culling excess labels) so that labels have sufficient
 * breathing room.
 * */
var PIXELS_PER_ANGLED_LABEL = exports.PIXELS_PER_ANGLED_LABEL = 30;
//# sourceMappingURL=cartesianLayout.js.map